import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { WfProduct } from 'src/api/wf/models/WfProduct';
import Button from '../../common/button/Button';
import P_CollapsibleSection from '../common/collapsibleSection/P_CollapsibleSection';
import { productDataColumns, productTableStyle } from './ProductDataColumns';
import { useTranslation } from 'react-i18next';
import { useWfProductStore } from 'src/api/wf/stores/WfProductStore';

type ProductsSectionProps = {
  products: WfProduct[];
};

export function ProductsSection({ products }: ProductsSectionProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setSelectedProduct } = useWfProductStore();
  return (
    <P_CollapsibleSection
      title={t('wf.siteDetails.targetedNumbers')}
      contentClassName="grid grid-flow-row text-left"
    >
      <DataTable
        className="size-full"
        noDataComponent={t('wf.common.noResults')}
        columns={productDataColumns(t, navigate, setSelectedProduct)}
        data={products}
        customStyles={productTableStyle}
        defaultSortFieldId="productNumber"
        defaultSortAsc={true}
        dense
      />
      <div className="flex justify-center space-x-4">
        <Button
          title={t('wf.common.back')}
          onClick={() => {
            navigate(-1);
          }}
        />
      </div>
    </P_CollapsibleSection>
  );
}
